import { render } from "./AppContainer.vue?vue&type=template&id=20bda22d&ts=true"
import script from "./AppContainer.vue?vue&type=script&lang=ts"
export * from "./AppContainer.vue?vue&type=script&lang=ts"

import "./AppContainer.vue?vue&type=style&index=0&id=20bda22d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__